"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogProvider = exports.buildDialogContext = void 0;
var React = require("react");
var bernie_core_1 = require("bernie-core");
var react_router_dom_1 = require("react-router-dom");
var dialog_context_1 = require("@shared-ui/dialog-context");
var layer_1 = require("./layer");
var dialogs_1 = require("./dialogs");
function buildDialogContext() {
    return {
        useDialogControl: function (id, dialogQueryKey, isOpen, setIsOpen) {
            var history = (0, react_router_dom_1.useHistory)();
            var location = (0, react_router_dom_1.useLocation)();
            var _a = (0, dialogs_1.useOpenedDialogContext)(), openedDialogs = _a.openedDialogs, dialogDispatch = _a.dialogDispatch;
            var openDialog = function (options) {
                var _a;
                if (openedDialogs.length > 0 && (options === null || options === void 0 ? void 0 : options.closeAllDialogs)) {
                    (0, bernie_core_1.updateSearch)({
                        history: history,
                        location: location,
                        newParams: {},
                        replace: true,
                        queryCombiner: function (prevQuery) {
                            var _a;
                            var nextQuery = (0, dialogs_1.filterQueryByAllDialogs)(prevQuery, openedDialogs);
                            return __assign(__assign({}, nextQuery), (_a = {}, _a[dialogQueryKey] = id, _a));
                        },
                    });
                }
                else {
                    (0, bernie_core_1.updateSearch)({ history: history, location: location, newParams: (_a = {}, _a[dialogQueryKey] = id, _a) });
                }
            };
            var closeDialog = function (options) {
                if (openedDialogs.length > 1 && (options === null || options === void 0 ? void 0 : options.closeAllDialogs)) {
                    (0, bernie_core_1.updateSearch)({
                        history: history,
                        location: location,
                        newParams: {},
                        replace: true,
                        queryCombiner: function (prevQuery) { return (0, dialogs_1.filterQueryByAllDialogs)(prevQuery, openedDialogs); },
                    });
                }
                else {
                    (0, bernie_core_1.closeDialog)({ history: history, location: location, key: dialogQueryKey });
                }
            };
            /**
             * Watch for query changes to decide whether or not to call setIsOpen, which will
             * be handled by the provider to actually flip the state of the dialog.
             *
             * Query watching and calling setIsOpen() should remain separate from the actions
             * that will update the URL query.
             *
             * How does this actually run in response to the url changing? The provider depends on
             * Location. If Location changes, so to does the value provided by the DialogContext.Provider
             */
            React.useEffect(function () {
                var _a;
                var queryParams = location.search || {};
                var shouldOpen = (0, bernie_core_1.matchesQuery)(queryParams, (_a = {}, _a[dialogQueryKey] = id, _a));
                if (shouldOpen !== isOpen) {
                    setIsOpen(shouldOpen);
                    dialogDispatch({ dialogId: id, isOpen: shouldOpen, key: dialogQueryKey });
                }
            }, [location]);
            return {
                ComponentFactory: React.useCallback(function (props) {
                    if (!isOpen) {
                        return null;
                    }
                    return (React.createElement(layer_1.Layer, { id: id, onDismiss: closeDialog }, props.children || null));
                }, [isOpen]),
                actions: {
                    closeDialog: closeDialog,
                    openDialog: openDialog,
                    toggleDialog: function () {
                        isOpen ? closeDialog() : openDialog();
                    },
                },
            };
        },
    };
}
exports.buildDialogContext = buildDialogContext;
var DialogProvider = function (_a) {
    var children = _a.children;
    var dialogContextValue = React.useMemo(function () { return buildDialogContext(); }, []);
    return (React.createElement(dialogs_1.OpenedDialogsProvider, null,
        React.createElement(dialog_context_1.DialogProvider, { value: dialogContextValue }, children)));
};
exports.DialogProvider = DialogProvider;
//# sourceMappingURL=dialog-context.js.map